import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants"

export const ADMIN_LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
export const CITYALERTS_LOCATION_HIE: any = ['COUNTRY', 'CITY', 'BLOCK']
export const NOWCAST_VIEW: any = {
    'ADMIN': 'Admin',
    'CITY': 'City'
}
export const NOWCAST_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        [NOWCAST_VIEW.ADMIN]: {
            'State Boundary': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary',
                visible: true,
                // hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'NOWCAST_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'State Boundaries': {
                source: 'INDIA',
                displayName: 'State Boundaries',
                name: 'State Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
                layer_name: 'State Boundaries',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'District Boundaries': {
                source: 'INDIA',
                displayName: 'District Boundaries',
                name: 'District Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'District Boundary': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Boundary',
                visible: true,
                // hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Boundary',
                layeroptions_pane: 'district',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'NOWCAST_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'Block Boundary': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Boundary',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Boundary',
                layeroptions_pane: 'state',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'NOWCAST_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'State Boundary Labels': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
                crs: 'EPSG4326',
            },
            'District Boundary Labels': {
                source: 'INDIA',
                displayName: 'District Boundary Labels',
                name: 'District Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'State_UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
            },
            'Block Boundary Labels': {
                source: 'INDIA',
                displayName: 'Block Boundary Labels',
                name: 'Block Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'Dist_UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
            },
            'District Layer': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Layer',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Layer',
                layeroptions_pane: 'district',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN + 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
            },
            'Block Layer': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Layer',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Layer',
                layeroptions_pane: 'state',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
            }
        },
        [NOWCAST_VIEW.CITY]: {
            'City Boundary': {
                source: 'INDIA',
                displayName: 'City',
                name: 'City Boundary',
                visible: true,
                // hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_MAJOR_CITIES',
                // layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
                layer_name: 'City Boundary',
                layeroptions_pane: 'depth',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'NOWCAST_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'City Boundaries': {
                source: 'INDIA',
                displayName: 'City Boundaries',
                name: 'City Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_MAJOR_CITIES',
                layer_name: 'City Boundaries',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'uuid_city',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'City Boundary Labels': {
                source: 'INDIA',
                displayName: 'City Boundary Labels',
                name: 'City Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_MAJOR_CITIES',
                layer_name: 'City Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_CITIES_NAME',
                crs: 'EPSG4326',
            },
            'Block Boundary': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Boundary',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Boundary',
                layeroptions_pane: 'state',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'NOWCAST_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'State Boundary Labels': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_STATE_NAMES_BORDER_NOWCAST',
                crs: 'EPSG4326',
            },
            'Block Boundary Labels': {
                source: 'INDIA',
                displayName: 'Block Boundary Labels',
                name: 'Block Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'Dist_UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
            },
            'KolkataOuter Boundaries': {
                source: 'INDIA',
                displayName: 'KolkataOuter Boundaries',
                name: 'KolkataOuter Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:Kolkata_outerboundary',
                layer_name: 'KolkataOuter Boundaries',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                // cql_filter_value: 'UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'Ward Boundary': {
                source: 'INDIA',
                displayName: 'Ward Boundary',
                name: 'Ward Boundary',
                visible: true,
                hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:KLKT_WARD_BOUNDARY',
                layer_name: 'Ward Boundary',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:WARD_BOUNDARY',
                legendName: 'NOWCAST_LEGEND',
                crs: 'EPSG4326',
                applycql_filter: true
            },
            'Ward Boundary Labels': {
                source: 'INDIA',
                displayName: 'Ward Boundary Labels',
                name: 'Ward Boundary Labels',
                visible: true,
                hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:KLKT_WARD_BOUNDARY',
                layer_name: 'Ward Boundary Labels',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'Administrative Boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:WARD_LABELS_KLKT',
                legendName: 'RADAR_LEGEND',
                crs: 'EPSG4326',
                applycql_filter: true
            }
        }
    }
}

export const NOWCAST_HEATMAP_LAYERLIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'HEATMAP': {
            source: 'INDIA',
            displayName: 'HEATMAP',
            name: 'HEATMAP',
            visible: false,
            // type: 'time',
            groupName: null,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            // layeroptions_name: 'HEATWAVE:GPM_Model_2_EV_input_25Apr2025_1430',
            layeroptions_name: 'HEATWAVE:observed',
            layer_name: 'HEATMAP',
            layeroptions_pane: 'state',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            // onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEO_URL',
            applycql_filter: true,
            crs: 'EPSG4326',
            // layeroptions_styles: 'HEATWAVE:nowcast_geotiff',
            layeroptions_styles: 'HEATWAVE:radar_geotiff',
            // layeroptions_protocol: 'WFS'
        },
    }
}

export const NOWCAST_GEOTIFF_LAYER: any = {
        'GEOTIFF': {
            source: 'INDIA',
            displayName: 'GEOTIFF',
            name: 'GEOTIFF',
            visible: false,
            // type: 'time',
            groupName: null,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            // layeroptions_name: 'HEATWAVE:GPM_Model_2_EV_input_25Apr2025_1430',
            layeroptions_name: 'HEATWAVE:observed',
            layer_name: 'GEOTIFF',
            layeroptions_pane: 'state',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: 'WMTS',
            type: 'WMTS',
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            // onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEO_URL',
            applycql_filter: true,
            crs: 'EPSG4326',
            // layeroptions_styles: 'HEATWAVE:nowcast_geotiff',
            // layeroptions_styles: 'HEATWAVE:radar_geotiff',
            // layeroptions_protocol: 'WFS'
        },
}

export const NOWCAST_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        NOWCAST_LEGEND: {
            "Units": "mm/hr ",
            "colorValues": [
                {
                    backgroundColor: 'transparent',
                    textColor: '#000000',
                    text: '0-0.5 (no rainfall)'
                },
                {
                    backgroundColor: '#e6eeff',
                    textColor: '#000000',
                    text: '0.5-2.5'
                },
                {
                    backgroundColor: '#80aaff',
                    textColor: '#000000',
                    text: '2.5-5'
                },
                {
                    backgroundColor: '#3377ff',
                    textColor: '#000000',
                    text: '5-10'
                },
                {
                    backgroundColor: '#003cb3',
                    textColor: '#000000',
                    text: '10-20'
                },
                {
                    backgroundColor: '#002266',
                    textColor: '#ffffff',
                    text: '20-30'
                },
                {
                    backgroundColor: '#ff80b3',
                    textColor: '#000000',
                    text: '30-40'
                },
                {
                    backgroundColor: '#ff0066',
                    textColor: '#000000',
                    text: '40-50'
                },
                {
                    backgroundColor: '#cc0000',
                    textColor: '#000000',
                    text: '50-75'
                },
                {
                    backgroundColor: '#660000',
                    textColor: '#ffffff',
                    text: '75-100'
                },
            ]
        }
    }
}

export const NOWCAST_SOURCES: any = {
    default: 'RADAR+CTT',
    sourceList: [
        {
            sourceName: 'RICKEN',
            displayName: 'RICKEN NOWCAST',
            uuid: '00cb31c7-2928-4e6d-adcc-443d478c90d6'
        },
        {
            sourceName: 'IMD RADAR',
            displayName: 'IMD NOWCAST',
            uuid: '00cb31c7-2928-4e6d-adcc-443d47898877'
        },
        {
            sourceName: 'RADAR+CTT',
            displayName: 'RADAR+CTT',
            uuid: '00cb31c7-2928-4e6d-adcc-443d47898877'
        },
        {
            sourceName: 'EUMETSAT',
            displayName: 'EUMETSAT',
            uuid: '00cb31c7-2928-4e6d-adcc-443d47898877'
        },
        {
            sourceName: 'CUSTOM',
            displayName: 'CUSTOM',
            uuid: '00cb31c7-2928-4e6d-adcc-443d47898877'
        }
    ]
}

export const KOLKATANOWCAST_SOURCES: any = {
    default: 'RADAR+CTT',
    sourceList: [
        {
            sourceName: 'EUMETSAT',
            displayName: 'EUMETSAT',
            uuid: '00cb31c7-2928-4e6d-adcc-443d478c90d6'
        },
        {
            sourceName: 'IMD RADAR',
            displayName: 'IMD NOWCAST',
            uuid: '00cb31c7-2928-4e6d-adcc-443d47898877'
        },
        {
            sourceName: 'RADAR+CTT',
            displayName: 'RADAR+CTT',
            uuid: '00cb31c7-2928-4e6d-adcc-443d47898877'
        }
    ]
}

export const NowcastMapConstants: any = {
    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
    }
}

export const NOWCAST_SOURCE_MAPPING: any = {
    'RICKEN': { 'source': 'RICKEN_NOWCAST', 'displaySource': 'JAXA' },
    'RADAR': { 'source': 'SIMPLE_RADAR_NOWCAST', 'displaySource': 'RAIN VIEWER' },
    'IMD RADAR': { 'source': 'IMD_RADAR_NOWCAST', 'displaySource': 'IMD' },
    'RADAR+CTT': { 'source': 'RADAR_CTT_EUMETSAT_NOWCAST', 'displaySource': 'IMD, EUMETSAT' },
    'EUMETSAT': { 'source': 'EUMETSAT_NOWCAST', 'displaySource': 'EUMETSAT' }
}

export const TIMESTAMP: any = [
    '202505081540',
    '202505081550',
    '202505081600',
    '202505081610',
    '202505081620',
    '202505081630',
    '202505081440',
    '202505081450',
    '202505081500',
    '202505081510',
    '202505081520',
    '202505081530'
]